import React from "react";
import { toast } from "react-toastify";
import profileImage from "../assets/img/avatars/profileImage.jpg";
import { handleAcceptRejectPayment } from "actions/actions";
const BASE_URL = process.env.REACT_APP_ENDPOINT;

const paymentTypeLabels = {
  bank: "تحويل بنكي",
  card: "بطاقة",
  cash: "نقدي",
  subscription: "اشتراك",
  offerUnlock: "فتح عرض",
};

const paymentRequestsColumns = (refetch) => [
  {
    Header: "المستخدم",
    accessor: "user",
    Cell: ({ row }) => {
      return (
        <div className="flex items-center gap-2">
          <img
            src={
              row.values.user.photo
                ? `${BASE_URL}/${row.values.user?.photo}`
                : profileImage
            }
            alt={row.values.user?.name}
            className="h-10 w-10 rounded-full border border-gray-200"
            crossOrigin="anonymous"
          />
          <span>{row.values.user?.name}</span>
        </div>
      );
    },
  },
  {
    Header: "رقم الهاتف",
    Cell: ({ row }) => {
      return (
        <a
          className="text-blue-500 hover:underline"
          href={`tel:${row.original.user.phoneNumber}`}
        >
          {row.original.user.phoneNumber}
        </a>
      );
    },
  },
  {
    Header: "البريد الإلكتروني",
    Cell: ({ row }) => {
      return (
        <a
          className="text-blue-500 hover:underline"
          href={`mailto:${row.original.user?.contractorInfo?.email}`}
        >
          {row.original.user?.contractorInfo?.email}
        </a>
      );
    },
  },
  {
    Header: "الاجمالي",
    accessor: "amount",
    Cell: ({ row }) => {
      return (
        <span className="text-center">
          {" "}
          {(row.values.amount ? row.values.amount : 0) + " ريال"}
        </span>
      );
    },
  },
  {
    Header: "الحالة",
    accessor: "status",
    Cell: ({ row }) => {
      return (
        <span
          className={`rounded-full px-2 py-1 text-xs font-semibold capitalize ${
            row.values.status === "completed"
              ? "bg-green-100 text-green-800"
              : row.values.status === "pending"
              ? "bg-yellow-100 text-yellow-800"
              : "bg-red-100 text-red-800"
          }`}
        >
          {row.values.status === "completed" && "مكتمل"}
          {row.values.status === "pending" && "قيد الانتظار"}
          {row.values.status === "rejected" && "مرفوض"}
        </span>
      );
    },
  },
  {
    Header: "النوع",
    accessor: "type",
    Cell: ({ row }) => {
      return (
        <span
          className={
            "rounded-full bg-gray-100 px-2 py-1 text-xs font-semibold capitalize text-gray-800"
          }
        >
          {paymentTypeLabels[row.values.type] || row.values.type || "-"}
        </span>
      );
    },
  },
  {
    Header: "تاريخ الإنشاء",
    accessor: "createdAt",
    Cell: ({ row }) => {
      const date = new Date(row.values.createdAt).toLocaleString("ar-EG", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
      return <span>{date}</span>;
    },
  },

  {
    Header: "إجراء",
    accessor: "id",
    Cell: ({ row }) => {
      return (
        <div className="flex flex-col items-start gap-2">
          {row.values.status === "completed" ||
          row.values.status === "rejected" ? (
            <span className="rounded-full bg-gray-300 px-2 py-1 text-xs font-semibold capitalize text-gray-400">
              لا يمكن التعديل
            </span>
          ) : (
            <>
              <button
                className=" rounded-full bg-green-500 px-6 py-1 text-white transition-all hover:bg-green-600 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-400"
                onClick={() =>
                  handleAcceptRejectPayment(row.original.id, "accept").then(
                    (res) => {
                      if (res.error) {
                        toast.error(res.error);
                      } else {
                        toast.success(res.success);
                        refetch();
                      }
                    }
                  )
                }
              >
                قبول
              </button>
              <button
                className="rounded-full bg-red-500 px-6 py-1 text-white transition-all hover:bg-red-600 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-400"
                onClick={() =>
                  handleAcceptRejectPayment(row.original.id, "reject").then(
                    (res) => {
                      if (res.error) {
                        toast.error(res.error);
                      } else {
                        toast.success(res.success);
                        refetch();
                      }
                    }
                  )
                }
              >
                رفض
              </button>
            </>
          )}
        </div>
      );
    },
  },
];

export { paymentRequestsColumns };
